export const NEW_USER = "newUser";
export const SELECTED_ORGANIZATION = "selectedOrganization";
export const ORGANIZATION_NOT_EXISTS = "organizationNotExists";
export const ACTIVE_SUBSCRIPTION_NOT_EXISTS = "activeSubscriptionNotExists";
export const USER_LOGIN = "user_login";
export const CARD_NOT_VALID = "cardNotValid";
export const REFERRER = "referrer";
export const LOGOUT_PATH = "/logout/"
